/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import CheckboxUncontrolled from "../ui/form/CheckboxUncontrolled";
import Text from "../ui/Text";

const SavePaymentMethodOption = ({ checked, onChange }) => {
  return (
    <CheckboxUncontrolled
      name="store_payment_method"
      defaultValue={checked}
      onChange={(e) => onChange(e.target.checked)}
    >
      <Text as="span" color="dark">
        Save my payment method for easy charging in my future purchases.
      </Text>
    </CheckboxUncontrolled>
  );
};

export default SavePaymentMethodOption;
